'use client';

import { c as _c } from "react/compiler-runtime";
import { useI18n } from '@udemy-v2/i18n';
import { useClpPurchaseContext } from '@/features/course-landing-page/context/clp-purchase-context.react-component';
import { useClpCourse } from '@/features/course-landing-page/context/clp-course-provider.react-component';
import { PlanPeriod, PlanPeriodStyle, SubscriptionCTA, SubscribeFromPageCookie } from '@udemy-v2/react-subscription-browse';
import styles from '../subscription-sticky-footer-content/subscription-sticky-footer-cta.module.scss';
import { useFeatures } from '@udemy-v2/react-experimentation';
const UI_REGION = 'non_catalog_pp_sticky_footer';
export const NonCatalogPPStickyFooterCta = () => {
  const $ = _c(25);
  const {
    gettext
  } = useI18n();
  const {
    nonCatalogPersonalPlan,
    nonCatalogSubscriptionCTAConfiguration
  } = useClpPurchaseContext();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["change_cta_language_for_pp"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    featureVariantAssignments
  } = useFeatures(t0);
  const changeCtaLangFeatureAssignment = featureVariantAssignments.get("change_cta_language_for_pp")?.configuration as {
    getStarted: boolean;
    getPersonalPlan: boolean;
  } | undefined;
  const course = useClpCourse();
  let t1;
  if ($[1] !== course.id) {
    t1 = () => {
      SubscribeFromPageCookie.set("course_landing_page", parseInt(course.id, 10));
    };
    $[1] = course.id;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handleCtaClick = t1;
  if (!nonCatalogPersonalPlan) {
    return null;
  }
  const ctaUrl = `/subscription-checkout/express/?non-catalog-course=${encodeURIComponent(course.id)}`;
  let t2;
  if ($[3] !== gettext) {
    t2 = config => {
      if (!config) {
        return gettext("Start subscription");
      }
      if (config.getStarted && !config.getPersonalPlan) {
        return gettext("Get started");
      }
      if (!config.getStarted && config.getPersonalPlan) {
        return gettext("Get Personal Plan");
      }
      return gettext("Start subscription");
    };
    $[3] = gettext;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const ctaText = t2;
  const t3 = "non-catalog-pp-sticky-footer";
  const t4 = "non-catalog-pp-sticky-footer";
  const t5 = styles["subscription-cta"];
  const T0 = SubscriptionCTA;
  const t6 = UI_REGION;
  const t7 = styles["cta-subtitle"];
  const t8 = "non-catalog-pp-sticky-footer-button";
  const t9 = "primary";
  const t10 = parseInt(course.id, 10);
  const t11 = false;
  const t12 = nonCatalogSubscriptionCTAConfiguration?.directCheckout ?? true;
  const t13 = nonCatalogSubscriptionCTAConfiguration?.purchaseCtaText ?? ctaText(changeCtaLangFeatureAssignment);
  let t14;
  if ($[5] !== ctaUrl) {
    t14 = {
      cta_1_url: ctaUrl
    };
    $[5] = ctaUrl;
    $[6] = t14;
  } else {
    t14 = $[6];
  }
  let t15;
  if ($[7] !== T0 || $[8] !== course.frontendTrackingId || $[9] !== handleCtaClick || $[10] !== nonCatalogPersonalPlan || $[11] !== t10 || $[12] !== t12 || $[13] !== t13 || $[14] !== t14 || $[15] !== t6 || $[16] !== t7) {
    t15 = <T0 uiRegion={t6} subtitleClassName={t7} data-purpose={t8} offerCtaStyle={t9} onCTAClick={handleCtaClick} courseId={t10} courseTrackingId={course.frontendTrackingId} includeTrialDaysOnCta={t11} plan={nonCatalogPersonalPlan} directCheckout={t12} purchaseCtaText={t13} noticeData={t14} showSubtitle={false} />;
    $[7] = T0;
    $[8] = course.frontendTrackingId;
    $[9] = handleCtaClick;
    $[10] = nonCatalogPersonalPlan;
    $[11] = t10;
    $[12] = t12;
    $[13] = t13;
    $[14] = t14;
    $[15] = t6;
    $[16] = t7;
    $[17] = t15;
  } else {
    t15 = $[17];
  }
  const t16 = !!nonCatalogPersonalPlan.annualPlanOption;
  let t17;
  if ($[18] !== nonCatalogPersonalPlan.formattedMonthlyAmount || $[19] !== t16) {
    t17 = <div className={styles["cta-subtitle"]}><PlanPeriod listPriceText={nonCatalogPersonalPlan.formattedMonthlyAmount} trialPeriodDays={0} showStartingAtPrice={t16} style={PlanPeriodStyle.SINGLE} /></div>;
    $[18] = nonCatalogPersonalPlan.formattedMonthlyAmount;
    $[19] = t16;
    $[20] = t17;
  } else {
    t17 = $[20];
  }
  let t18;
  if ($[21] !== t15 || $[22] !== t17 || $[23] !== t5) {
    t18 = <div data-testid={t3} data-purpose={t4} className={t5}>{t15}{t17}</div>;
    $[21] = t15;
    $[22] = t17;
    $[23] = t5;
    $[24] = t18;
  } else {
    t18 = $[24];
  }
  return t18;
};